import { useState } from 'react'
import {
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View
} from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// styles
import { colorPalette, globalStyles } from '../../static/styles/global'

// components & screens
import Card from '../../components/shared/card/Card'
import CustomButton from '../../components/shared/button/Button'
import CardSeparator from '../../components/shared/card/CardSeparator'
import ModalConfrim from '../../components/shared/modal/ModalConfirm'
import MyScrollView from '../../components/shared/navigator/MyScrollView'

const ConfirmScheduleAvailabilityScreen = ({ navigation }): JSX.Element => {
  const [modalVisible, setModalVisible] = useState(false)

  const handleConfirmAvailability = (): void => {
    setModalVisible(!modalVisible)
  }

  const handleNavigateBackToWelcome = (): void => {
    setModalVisible(!modalVisible)
    navigation.navigate('Home', { status: 'confirmed' })
  }

  return (
    <MyScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.hBetweenItems,
              globalStyles.mb3
            ]}
          >
            <TouchableOpacity
              style={[
                globalStyles.hDirection,
                globalStyles.vCenterItems,
                globalStyles.flexOne
              ]}
              onPress={() => {
                navigation.goBack()
              }}
            >
              <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
                <Ionicons
                  name="chevron-back"
                  size={24}
                  color={colorPalette.white}
                />
              </View>
              <Text
                style={[
                  globalStyles.text,
                  globalStyles.fwBold,
                  globalStyles.fs20,
                  globalStyles.whiteTextColor,
                  globalStyles.ml0
                ]}
              >
                Confirm Schedule Availability
              </Text>
            </TouchableOpacity>
            <View></View>
          </View>

          <View>
            <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
              Enter hours for which you are available to be scheduled for a
              shift.
            </Text>
          </View>
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View style={[globalStyles.mb4]}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwSemiBold,
                globalStyles.blackTextColor,
                { marginBottom: 2 }
              ]}
            >
              Your Store Location is: Woodland Plaza
            </Text>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fs12,
                globalStyles.secondaryTextColor,
                globalStyles.mb3
              ]}
            >
              12345 Southern Main St., Fredericksburg, VA 00000
            </Text>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fs12,
                globalStyles.grayTextColor
              ]}
            >
              Working Hours: Sunday – Saturday 8am – 5pm (All Day)
            </Text>
          </View>
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.hBetweenItems,
              globalStyles.vCenterItems
            ]}
          >
            <Text
              style={[
                globalStyles.flexOne,
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.primaryTextColor,
                globalStyles.pr3
              ]}
            >
              Requested Hours Per Week
            </Text>
            <View style={[{ width: 85 }]}>
              <TextInput style={[globalStyles.input]} placeholder={'Number'} />
            </View>
          </View>
          <CardSeparator />

          <View style={[globalStyles.mb4]}>
            <View style={[globalStyles.hDirection, globalStyles.hvCenterItems]}>
              <View style={[styles.dayNameCol]}>
                <Text
                  style={[
                    globalStyles.text,
                    globalStyles.fwBold,
                    globalStyles.primaryTextColor
                  ]}
                >
                  Monday
                </Text>
              </View>
              <View style={[globalStyles.flexOne]}>
                <Text
                  style={[globalStyles.text, globalStyles.primaryTextColor]}
                >
                  Available All Day
                </Text>
              </View>
            </View>
          </View>
          {/* day availability */}

          <View style={[globalStyles.mb4]}>
            <View style={[globalStyles.hDirection, globalStyles.hvCenterItems]}>
              <View style={[styles.dayNameCol]}>
                <Text
                  style={[
                    globalStyles.text,
                    globalStyles.fwBold,
                    globalStyles.primaryTextColor
                  ]}
                >
                  Tuesday
                </Text>
              </View>
              <View style={[globalStyles.flexOne]}>
                <Text
                  style={[globalStyles.text, globalStyles.primaryTextColor]}
                >
                  Available 10:00 AM – 2:00 PM
                </Text>
              </View>
            </View>
          </View>
          {/* day availability */}

          <View style={[globalStyles.mb4]}>
            <View style={[globalStyles.hDirection, globalStyles.hvCenterItems]}>
              <View style={[styles.dayNameCol]}>
                <Text
                  style={[
                    globalStyles.text,
                    globalStyles.fwBold,
                    globalStyles.primaryTextColor
                  ]}
                >
                  Wednesday
                </Text>
              </View>
              <View style={[globalStyles.flexOne]}>
                <Text
                  style={[globalStyles.text, globalStyles.primaryTextColor]}
                >
                  Not Available
                </Text>
              </View>
            </View>
            <View style={[globalStyles.ml4, globalStyles.mt2]}>
              <Text style={[globalStyles.text, globalStyles.grayTextColor]}>
                Note: Volunteer at elementary school
              </Text>
            </View>
            {/* note */}
          </View>
          {/* day availability */}

          <View style={[globalStyles.mb4]}>
            <View style={[globalStyles.hDirection, globalStyles.hvCenterItems]}>
              <View style={[styles.dayNameCol]}>
                <Text
                  style={[
                    globalStyles.text,
                    globalStyles.fwBold,
                    globalStyles.primaryTextColor
                  ]}
                >
                  Thursday
                </Text>
              </View>
              <View style={[globalStyles.flexOne]}>
                <Text
                  style={[globalStyles.text, globalStyles.primaryTextColor]}
                >
                  Available All Day
                </Text>
              </View>
            </View>
          </View>
          {/* day availability */}

          <View style={[globalStyles.mb4]}>
            <View style={[globalStyles.hDirection, globalStyles.hvCenterItems]}>
              <View style={[styles.dayNameCol]}>
                <Text
                  style={[
                    globalStyles.text,
                    globalStyles.fwBold,
                    globalStyles.primaryTextColor
                  ]}
                >
                  Friday
                </Text>
              </View>
              <View style={[globalStyles.flexOne]}>
                <Text
                  style={[globalStyles.text, globalStyles.primaryTextColor]}
                >
                  Available All Day
                </Text>
              </View>
            </View>
          </View>
          {/* day availability */}

          <View style={[globalStyles.mb4]}>
            <View style={[globalStyles.hDirection, globalStyles.hvCenterItems]}>
              <View style={[styles.dayNameCol]}>
                <Text
                  style={[
                    globalStyles.text,
                    globalStyles.fwBold,
                    globalStyles.primaryTextColor
                  ]}
                >
                  Saturday
                </Text>
              </View>
              <View style={[globalStyles.flexOne]}>
                <Text
                  style={[globalStyles.text, globalStyles.primaryTextColor]}
                >
                  Available 10:00 AM – 2:00 PM
                </Text>
              </View>
            </View>
          </View>
          {/* day availability */}

          <View style={[globalStyles.mb4]}>
            <View style={[globalStyles.hDirection, globalStyles.hvCenterItems]}>
              <View style={[styles.dayNameCol]}>
                <Text
                  style={[
                    globalStyles.text,
                    globalStyles.fwBold,
                    globalStyles.primaryTextColor
                  ]}
                >
                  Sunday
                </Text>
              </View>
              <View style={[globalStyles.flexOne]}>
                <Text
                  style={[globalStyles.text, globalStyles.primaryTextColor]}
                >
                  Not Available
                </Text>
              </View>
            </View>
          </View>
          {/* day availability */}
        </Card>
      </View>
      <View style={[globalStyles.horizontalPadGap, globalStyles.mb8]}>
        <CustomButton
          text={'Confirm Availability'}
          onPress={handleConfirmAvailability}
        />
        <TouchableOpacity
          onPress={() => {
            navigation.navigate('ScheduleAvailability')
          }}
        >
          <Text
            style={[
              globalStyles.text,
              globalStyles.textCenter,
              globalStyles.textUnderline,
              globalStyles.secondaryTextColor,
              globalStyles.mt3
            ]}
          >
            Edit Default Schedule Availability
          </Text>
        </TouchableOpacity>
      </View>
      <ModalConfrim
        title="Success!"
        message="Success! Your default schedule availability has been submitted."
        visible={modalVisible}
        setVisible={setModalVisible}
        action={handleNavigateBackToWelcome}
      />
    </MyScrollView>
  )
}

const styles = StyleSheet.create({
  dayNameCol: {
    width: 110
  }
})

export default ConfirmScheduleAvailabilityScreen
